<!-- 服务项目信息编辑页 -->
<template>
  <div class="edit white">
    <el-dialog :title="addEditTitle" :visible.sync="addEditShow" width="620px" :before-close="handleChangeDrawer" :close-on-click-modal="false">
        <div class="pay-mains">
          <el-form ref="form" :model="form" class="demo-ruleForm" label-width="120px" label-position="left">
              <!-- v-if="!$store.getters.ShopInfo.shopBizConfig.easyStaffFlag" -->
            <el-form-item class="flex-row" label="手机号码：">{{oldForm.mobile}}</el-form-item>
            <el-form-item class="flex-row" ref="idCardNo" label="身份证号码：" prop="idCardNo" :rules="$rules.cardNum" v-if="$store.getters.ShopInfo.shopBizConfig.yuanyuanFlag">
              <el-input v-model="form.idCardNo" placeholder="请输入身份证号码" maxlength="18"></el-input>
            </el-form-item>
			<el-form-item class="flex-row" ref="idCardNo" label="身份证号码：" prop="idCardNo" :rules="$rules.cardNumNoRequired" v-if="!$store.getters.ShopInfo.shopBizConfig.yuanyuanFlag">
			  <el-input v-model="form.idCardNo" placeholder="请输入身份证号码" maxlength="18"></el-input>
			</el-form-item>
            <el-form-item ref="idCardFrontUrl" label="身份证照片：" required class="item-cards" v-if="$store.getters.ShopInfo.shopBizConfig.yuanyuanFlag">
              <div class="flex-row">
                <div class="front card-box mr20">
                  <imgUpload @file="getFileCardFront" :fileList="idCardFrontUrl" module="memberMobile"></imgUpload>
                  <p class="divCenter">身份证正面照</p>
                </div>
                <div class="back card-box">
                  <imgUpload @file="getFileCarBack" :fileList="idCardBackUrl" module="memberMobile"></imgUpload>
                  <p class="divCenter">身份证反面照</p>
                </div>
              </div>
            </el-form-item>
			<el-form-item ref="idCardFrontUrl2" label="身份证照片：" class="item-cards" v-if="!$store.getters.ShopInfo.shopBizConfig.yuanyuanFlag">
			  <div class="flex-row">
			    <div class="front card-box mr20">
			      <imgUpload @file="getFileCardFront" :fileList="idCardFrontUrl" module="memberMobile"></imgUpload>
			      <p class="divCenter">身份证正面照</p>
			    </div>
			    <div class="back card-box">
			      <imgUpload @file="getFileCarBack" :fileList="idCardBackUrl" module="memberMobile"></imgUpload>
			      <p class="divCenter">身份证反面照</p>
			    </div>
			  </div>
			</el-form-item>
             <el-form-item
              class="flex-row"
              ref="newMobile"
              label="新手机号码："
              prop="newMobile"
              :rules="$rules.required"
            >
              <el-input v-model="form.newMobile" placeholder="请输入手机号码" maxlength="11"></el-input>
              <!--  -->
            </el-form-item>
            <el-form-item
              class="flex-row"
              ref="verifyCode"
              label="验证码："
              prop="verifyCode"
              :rules="$rules.required"
            >
              <div class="flex-row">
                <el-input placeholder="输入验证码" v-model="form.verifyCode" maxlength="6" v-if="!codeName">
                  <span slot="suffix" class="cur jishi">{{ codeName ? '获取验证码':time+'s'}}</span>
                </el-input>
                <el-input placeholder="输入验证码" v-model="form.verifyCode" maxlength="6" v-else>
                  <span slot="suffix" class="cur jishi" @click="addLoginCode">{{ codeName ? '获取验证码':time+'s'}}</span>
                </el-input>
                <!-- <el-link
                  type="success"
                  @click="addLoginCode"
                  :disabled="!codeName"
                >{{ codeName ? '获取短信验证码':time+'s'}}</el-link> -->
              </div>
            </el-form-item>
          </el-form>
        </div>
        <div slot="footer" class="dialog-footer">
          <div class="btns">
            <el-button @click="changeRecord">变更记录</el-button>
            <el-button type="primary" @click="save">确定</el-button>
          </div>
        </div>
    </el-dialog>
    <!-- <position-page ref="positionSetForm" @handleChange="changePosiitonPage"></position-page> -->
    <mobileRecord ref="mobileRecord"></mobileRecord>
  </div>
</template>

<script>
import imgUpload from "../../components/common/modules/uploads";
import imgUploadHead from "../../components/common/modules/upload-head";
// import positionPage from "./position_page";
import drawer from "../../components/common/drawer";
import minxin from "../../assets/javascript/minxin.js";
import { decrypt, encrypt } from "../../assets/javascript/untils";
import mobileRecord from "./mobileRecord.vue"
export default {
  data() {
    return {
      codeName: true,
      time: 60,
      addEditShow: false,
      addEditTitle: "",
      form: {
        mobile: "", //联系电话
        verifyCode: "", //验证码
        idCardBackUrl: "", //身份证反面
        idCardFrontUrl: "", //身份证正面
        idCardNo: "", //身份证号码
      },
      idCardFrontUrl: '',
      idCardBackUrl: '',
      oldForm: {},
    };
  },
  mixins: [minxin],
  components: {
    imgUpload,
    imgUploadHead,
    mobileRecord,
    // positionPage,
    drawer
  },

  computed: {},

  created() {
	console.log(this.yuanyuanFlag)
    this.init();
  },
  methods: {
    back() {
      //   this.$router.push("/collectMoney");
      this.addEditShow = false;
      this.$refs['form'].resetFields();
    },
    changeRecord () {
        // 变更记录
        this.$refs["mobileRecord"].$emit("set", {id: this.oldForm.id});
    },
    addLoginCode() {
      if (this.form.newMobile == "") {
        this.$message.error("请输入手机号码");
        return false;
      }
      if (this.form.newMobile.length != 11) {
        this.$message.error("请输入正确的手机号码");
        return false;
      }
      let arr = encrypt(
        JSON.stringify({
          mobile: this.form.newMobile,
          bizType: "changeMobile",
          millisecond: new Date().getTime()
        })
      );
      this.$api.post(this.$url.send, arr).then(resp => {
        if (resp) {
          this.codeName = false;
          this.$message.success("短信发送成功")
        } else {
          this.codeName = true;
          clearInterval(auth_timetimer);
        }
        this.time = 60;
      });
      let auth_timetimer = setInterval(() => {
        if (this.time <= 0) {
          this.time = 60;
          this.codeName = true;
          clearInterval(auth_timetimer);
        }
        this.time--;
      }, 1000);
    },
    getFileCardFront(res) {
      //身份证正面
      if (this.form.idCardFrontUrl) {
        this.ossMerchatDelImg({imgUrl: this.form.idCardFrontUrl});
      }
      this.form.idCardFrontUrl = res.oldImgUrl;
      this.idCardFrontUrl = res.newImgUrl;
    },
    getFileCarBack(res) {
      //身份证反面
      if (this.form.idCardBackUrl) {
        this.ossMerchatDelImg({imgUrl: this.form.idCardBackUrl});
      }
      this.form.idCardBackUrl = res.oldImgUrl;
      this.idCardBackUrl = res.newImgUrl;
    },
    //  页面初始化函数
    init() {
      this.$on("set", function(item) {
        Object.assign(this.$data, this.$options.data());
        console.log(item)
        this.addEditShow = true;
        this.addEditTitle = "修改手机号";
        this.oldForm = item;
      });
    },
    handleChangeDrawer(val) {
      this.$refs["form"].clearValidate();
      this.addEditShow = false;
    },
    // 保存
    save() {
      var yuanyuanFlag = this.$store.getters.ShopInfo.shopBizConfig.yuanyuanFlag;
      console.log(this.form);
      this.$refs.form.validate((valid, object) => {
        if (valid) {
          if (!this.form.idCardFrontUrl && yuanyuanFlag) {
            return this.$message.error("请上传身份证正面照");
          } else if (!this.form.idCardBackUrl  && yuanyuanFlag) {
            return this.$message.error("请上传身份证反面照");
          }
          this.form.memberId = this.oldForm.id;
          this.$api.post(this.$url.member.saveMobile, this.form).then(res => {
              if (res) {
                  this.$api.success();
                  this.addEditShow = false;
                  this.$emit("handleChange", true);
              }
          }); 
        } else {
          this.scrollView(object);
        }
      });
    },
    // //滚动到指定位置
    scrollView(object) {
      for (let i in object) {
        let dom = this.$refs[i];
        dom.$el.scrollIntoView({
          block: "center",
          behavior: "smooth"
        });
        break;
      }
    }
  }
};
</script>
<style scoped lang="less">
@import "../../assets/css/edit.less";
.pay-mains {
  padding: 0;
  height: 100%;
    /deep/ .el-form-item__content {
        width: 217px !important;
    }
      /deep/ .el-input-group__append {
        padding: 0 10px !important;
      }
      .idcard {
        display: flex;
        .card-box {
          width: 168px;
          text-align: center;
        }
    }
  /deep/ .el-form {
    padding-bottom: 20px;
    /deep/ .el-form-item {
      background: #fff;
    //   border-bottom: 1px solid @borderColor;
      padding: 10px 0;
      // margin-bottom: 0;
      &:last-child {
        border-bottom: 0;
      }
      
    }
    
    
    .el-form-item-update {
      padding: 5px 20px;
      height: 46px;
      align-items: center;
      display: flex;
      margin: 0;
      justify-content: space-between;
      border-bottom: 1px solid @borderColor;
      /deep/ .el-form-item__label {
        font-size: 16px;
        font-weight: 500;
        // text-align: left;
      }
      /deep/ .el-form-item__content {
        
        .el-form-item__error {
          right: 0;
        }
      }
      /deep/ .el-input__inner {
        height: 46px;
      }
      /deep/.el-select .el-input__inner {
        padding: 0 30px;
      }
      /deep/ .el-radio__inner {
        width: 22px;
        height: 22px;
      }
      /deep/ .el-radio__label {
        font-size: 16px;
      }

      /deep/ .el-input.is-disabled .el-input__inner {
        background: #fff;
      }
      /deep/ .el-link {
        width: 160px;
      }
    }
    .head-img {
      height: 90px;
      width: 100%;
      box-sizing: border-box;
      /deep/ .el-form-item__content {
        .top-img {
          width: 100%;
          display: flex;
          justify-content: space-between;
          position: relative;
          .text-upload {
            position: absolute;
            top: 20px;
            right: 0;
            line-height: initial;
          }
        }
        .el-link {
          width: auto;
          cursor: pointer;
        }
        .img {
          width: 60px;
          height: 60px;
        }
      }
    }
  }
}
    .item-cards {
      background: #fff;
      padding: 10px 0;
      margin-bottom: 0;
      /deep/ .el-form-item__content {
          margin-left: 27px !important;
      }
    }
</style>